import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import useAccountType from './useAccountType';

const useRBACPermissions = () => {
  const { isCurrentUserAdminOrSuperUser } = useAccountType();
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isRBACEnabledFF = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isRBACEnabled
  });
  const isPermitted = isRBACEnabledFF ? isCurrentUserAdminOrSuperUser : true;

  return { isPermitted };
};

export default useRBACPermissions;
